import { 
    useState, 
    useEffect,
    useLayoutEffect
} from "react";
import { useSelector } from "react-redux";
import {
    select_authenticated,
    select_director
} from "../stores/authSlice";
import { VIEWPORT_BREAKPOINTS } from "./config";

export function useScreenType() {
    const [size, setSize] = useState({ width: undefined, height: undefined });
    const isMobile = size.width <= VIEWPORT_BREAKPOINTS.MOBILE;
    const isDesktop_HD = (size.width > VIEWPORT_BREAKPOINTS.MOBILE && size.width <= VIEWPORT_BREAKPOINTS.DESKTOP_HD);
    const isDesktop_2K = (size.width > VIEWPORT_BREAKPOINTS.DESKTOP_HD && size.width <= VIEWPORT_BREAKPOINTS.DESKTOP_2K);
    const isDesktop_4K = (size.width > VIEWPORT_BREAKPOINTS.DESKTOP_2K && size.width <= VIEWPORT_BREAKPOINTS.DESKTOP_4K);

    useEffect(() => {
        const handleResize = () => {
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return {
        isMobile,
        isDesktop_HD,
        isDesktop_2K,        
        isDesktop_4K
    }
}

export function useAuth() {
    const authenicated = useSelector(select_authenticated);

    return authenicated;
}

export function useDirector() {
    const director = useSelector(select_director);

    return director;
}


export function useFilters() {
    const [filters, setFilters] = useState([]);

    const handleFilterClick = (filter) => {
        // clicked on already selected filter
        if(filters.includes(filter)) {
            setFilters(filters.filter(f => f !== filter));

        } else {
            setFilters([...filters, filter]);

        }
    }

    return { filters, handleFilterClick }
}

export function useSearch() {
    const [search, setSearch] = useState("");

    const handleSearchChange = (e) => {
        setSearch(e.target.value.toLowerCase());

    }

    return { search, handleSearchChange }
}

// given the number of columns, finds the props for the FixedSizedGrid
export function useGetFixedSizedGridProps(
    gridRef, 
    gridColumnCount,
    numGridItems,
    itemRef
) {
    const [gridProps, setGridProps] = useState(null);
    
    const columnCount = numGridItems < gridColumnCount ? numGridItems : gridColumnCount;
    const rowCount = Math.ceil(numGridItems / gridColumnCount);

    useLayoutEffect(() => {
        // safe to call as invoked after refs are assigned
        const handleResize = () => {

            setGridProps({
                width: gridRef.current.offsetWidth,
                height: gridRef.current.offsetHeight,
                columnWidth: itemRef.current.offsetWidth,
                rowHeight: itemRef.current.offsetHeight,
                columnCount,
                rowCount
            });
        }

        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }

    }, [columnCount, rowCount, gridRef, itemRef]);

    return gridProps;
}

export function useRateLimit(handler, callback, rate) {
    const [isRateLimited, setIsRateLimited] = useState(false); 
    let timeout;

    const rateLimitedHandler = () => {
        try {
            if(!isRateLimited) {
                setIsRateLimited(true);
                timeout = setTimeout(() => {
                    // release the rate limit
                    setIsRateLimited(false)
                }, rate);
                
                if(typeof handler === "function") {
                    handler();
                }
            }

            if(isRateLimited) {
                if(typeof callback === "function") {
                    callback();
                }
            }

        } catch {
            // if error occurs allows instant retry
            setIsRateLimited(false);
            clearTimeout(timeout);
        }
    }

    return { isRateLimited, rateLimitedHandler }
}